function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29284_16391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5C13.1423 1.5 16.5 4.85775 16.5 9C16.5 13.1423 13.1423 16.5 9 16.5C4.85775 16.5 1.5 13.1423 1.5 9H3C3 12.3135 5.6865 15 9 15C12.3135 15 15 12.3135 15 9C15 5.6865 12.3135 3 9 3C7.152 3 5.499 3.8355 4.39875 5.14875L6 6.75H1.5V2.25L3.33525 4.0845C4.71 2.502 6.738 1.5 9 1.5ZM9.75 5.25V8.68875L12.1823 11.121L11.121 12.1823L8.25 9.30975V5.25H9.75Z",
    fill: "#4A4A68",
    style: {
      fill: "#4A4A68",
      fill: "color(display-p3 0.2902 0.2902 0.4078)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29284_16391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogMobile);
export default __webpack_public_path__ + "static/media/logMobile.18a1ccafc3161934e8c4d19dadae66b2.svg";
export { ForwardRef as ReactComponent };